<script>
  import { syncStatus, pendingSyncCount } from '../stores/app.js'
  import { auth, currentUser } from '../stores/auth.js'
  import { createEventDispatcher } from 'svelte'

  const dispatch = createEventDispatcher()

  $: isOnline = $syncStatus.isOnline
  $: isSyncing = $syncStatus.isSyncing
  $: isSyncButtonDisabled = !isOnline || isSyncing

  let showUserMenu = false

  function handleSync() {
    dispatch('sync')
  }

  function toggleUserMenu() {
    showUserMenu = !showUserMenu
  }

  function handleUserManagement() {
    showUserMenu = false
    dispatch('navigate', { view: 'userManagement' })
  }

  function handleImport() {
    showUserMenu = false
    dispatch('navigate', { view: 'import' })
  }

  async function handleLogout() {
    const confirmed = confirm('確定要登出嗎？')
    if (confirmed) {
      await auth.logout()
      showUserMenu = false
      // Reload page to reset state
      window.location.reload()
    }
  }

  // Close menu when clicking outside
  function handleClickOutside(e) {
    if (showUserMenu && !e.target.closest('.user-menu-container')) {
      showUserMenu = false
    }
  }
</script>

<svelte:window on:click={handleClickOutside} />

<header class="fixed top-0 left-0 right-0 bg-white border-b border-gray-200 z-10">
  <div class="container mx-auto px-4 py-3 flex items-center justify-between">
    <div class="flex items-center">
      <h1 class="text-xl font-bold text-primary-600">Wild Train</h1>
    </div>

    <div class="flex items-center">
      <!-- User menu -->
      {#if $currentUser}
        <div class="relative user-menu-container">

          <button
            on:click={toggleUserMenu}
            class="flex items-center gap-2 px-3 py-2 rounded-md hover:bg-gray-100 transition-colors"
            aria-label="使用者選單"
          >
            <!-- Online status indicator -->
            <div class="text-sm text-gray-500">
              {#if isSyncing}
                <span class:animate-pulse={isSyncing} class="text-yellow-600">●</span>
              {:else if isOnline}
                <span class="text-green-600">●</span>
              {:else}
                <span class="text-orange-600">●</span>
              {/if}
            </div>

            <div class="w-8 h-8 bg-primary-500 rounded-full flex items-center justify-center text-white font-medium">
              {$currentUser.name ? $currentUser.name[0].toUpperCase() : '?'}
            </div>
            <span class="hidden md:inline text-sm font-medium text-gray-700">
              {$currentUser.name || $currentUser.email}
            </span>
            <span class="text-gray-400 text-xs">▼</span>
          </button>

          {#if showUserMenu}
            <div class="absolute right-0 mt-2 w-56 bg-white rounded-md shadow-lg border border-gray-200 py-1 z-20">
              <div class="px-4 py-2 border-b border-gray-200">
                <p class="text-sm font-medium text-gray-900">{$currentUser.name}</p>
                <p class="text-xs text-gray-500">{$currentUser.email}</p>
              </div>

              <!-- Sync button -->
              <div class="px-4 border-b border-gray-200 hover:bg-gray-50">
                <button
                  on:click={handleSync}
                  disabled={isSyncButtonDisabled || isSyncing}
                  class="w-full text-left py-2 text-sm text-gray-900 transition-colors flex items-center gap-2"
                  aria-label="同步資料"
                >
                  <span class:animate-spin={isSyncing} class="inline-block">↻</span>
                  {#if $pendingSyncCount > 0}
                    <span class="bg-orange-100 text-orange-600 px-2 py-0.5 rounded-full text-xs ml-auto">
                      {$pendingSyncCount > 99 ? '99+' : $pendingSyncCount}
                    </span>
                  {/if}
                  <span>同步資料</span>
                </button>
              </div>

              <!-- User Management button -->
              <div class="border-b border-gray-200">
                <button
                  on:click={handleUserManagement}
                  class="w-full text-left px-4 py-2 text-sm text-gray-900 hover:bg-gray-50 transition-colors"
                >
                  👥 使用者管理
                </button>

              <!-- Import Data button -->
                <button
                  on:click={handleImport}
                  class="w-full text-left px-4 py-2 text-sm text-gray-900 hover:bg-gray-50 transition-colors"
                >
                  📥 資料匯入（測試中）
                </button>
              </div>

              <!-- Logout button -->
              <button
                on:click={handleLogout}
                class="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"
              >
                ➜] 登出
              </button>
            </div>
          {/if}
        </div>
      {/if}
    </div>
  </div>
</header>

<!-- Spacer to prevent content from being hidden under fixed header -->
<div class="h-14"></div>
